import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/img/logo.png";
import useAuthService from "../../auth/AuthService";
import SearchComponent from "../SearchComponent/SearchComponent";
import Button from "../Button/Button";
import NavbarDropdown from "../NavbarDropdown/NavbarDropdown";
import { fetchUserProfile } from "../../services/external.api.service";
import { UserData } from "../../types/types";
//import Slab from "../Slab/Slab";
import "./Header.css";
//import { GetCartItems, RemoveFromCart } from "../../services/cart.service";
//import { handleMessage } from "../../utils/handleMessagePopup";
import { StripeCheckoutForm } from "../Stripe/StripeCheckoutForm/StripeCheckoutForm";
import SearchSideBar from "../HeaderSidebars/SearchSidebar";
import HamburgerSidebar from "../HeaderSidebars/HamburgerSidebar";
import { Search } from "../../services/search.service";

const Header: React.FC<{
  profileImageUrl: string;
  handleDeletionInCart: (item_id: string) => void;
  handleImageChange: (image_url: string) => void;
  handleCartOpen: () => void;
  setCartOpen: boolean;
  handleUserRole: (role: string) => void;
  isNewNotification?: boolean;
  isFocusSearch?: boolean;
}> = ({
  profileImageUrl,
  handleImageChange,
  handleCartOpen,
  setCartOpen,
  handleUserRole,
  isNewNotification,
  isFocusSearch,
}) => {
  const { logout, isAuthenticated, login, signup, getToken } = useAuthService();

  const [state, setState] = useState({
    isCartDropdownOpen: false,
    isUserDropdownOpen: false,
    isMessageDropdownOpen: false,
    isCartLoading: false,
    isCheckoutOpen: false,
    userProfileUrl: "",
    totalValue: 0.0,
    error: "",
    isIconHover: false,
    isMessageHover: false,
    isLeftSidebarOpen: false,
    isRightSidebarOpen: false,
    role: "",

    searchResults: [] as any[],
    cart_items: [] as {
      id: "";
      item_id: "";
      item_image_url: "";
      item_name: "";
      item_price: 0;
      quantity: 0;
      status: "";
      user_id: "";
    }[],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (isAuthenticated) {
          const userProfileData = await fetchUserProfile(getToken);

          if (userProfileData.data !== null && userProfileData.error === null) {
            const userData: UserData = userProfileData.data.user;
            handleImageChange(userData.user_profile_url || "");
            handleUserRole(userData.role_name || "");

            setState((prev) => ({
              ...prev,
              userProfileUrl: userData.user_profile_url || "",
              role: userData.role_name || "",
            }));
          }
        }
      } catch {
        console.error("User not authenticated or user ID not available");
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, [isAuthenticated]);

  useEffect(() => {
    if (setCartOpen) {
      setState((pre) => ({ ...pre, isCartDropdownOpen: true }));
      handleCartOpen();
    }
  }, [setCartOpen, handleCartOpen]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (state.isCartDropdownOpen) {
  //       try {
  //         setState((pre) => ({ ...pre, isCartLoading: true }));
  //         const response = await GetCartItems(getToken);

  //         // If there is an error or empty data, reset the cart and total value
  //         if (response.error == null && response.data.cartItems == null) {
  //           setState((prev) => ({
  //             ...prev,
  //             isCartLoading: false,
  //             cart_items: [],
  //             totalValue: 0, // Reset total value
  //           }));
  //           return;
  //         }

  //         if (response.error === null) {
  //           // Create a new array of cart items
  //           const newCartItems = response.data.cartItems.map((item: any) => ({
  //             id: item.id,
  //             item_id: item.entity_id,
  //             item_image_url: item.image_url,
  //             item_name: item.name,
  //             item_price: item.price,
  //             quantity: item.quantity,
  //             status: item.status,
  //             user_id: item.user_id,
  //           }));

  //           setState((prev) => ({
  //             ...prev,
  //             error: "",
  //             isCartLoading: false,
  //             cart_items: [...newCartItems], // Set the new cart items
  //             totalValue: response.data.total, // Set the total value
  //           }));
  //         }
  //       } catch {
  //         setState((pre) => ({ ...pre, isCartLoading: false }));
  //         console.error("Unable to get cart items");
  //       }
  //     }
  //   };
  //   fetchData();
  // }, [getToken, state.isCartDropdownOpen]);

  // const handleGetCartItems = async () => {
  //   try {
  //     if (isAuthenticated) {
  //       toggleState("isCartLoading");
  //       const response = await GetCartItems(getToken);

  //       // If there is an error or empty data, reset the cart and total value
  //       if (response.error == null && response.data.cartItems == null) {
  //         setState((prev) => ({
  //           ...prev,
  //           cart_items: [],
  //           totalValue: 0, // Reset total value
  //         }));
  //         toggleState("isCartLoading", false);
  //         return;
  //       }

  //       if (response.error === null) {
  //         // Create a new array of cart items
  //         const newCartItems = response.data.cartItems.map((item: any) => ({
  //           id: item.id,
  //           item_id: item.entity_id,
  //           item_image_url: item.image_url,
  //           item_name: item.name,
  //           item_price: item.price,
  //           quantity: item.quantity,
  //           status: item.status,
  //           user_id: item.user_id,
  //         }));

  //         setState((prev) => ({
  //           ...prev,
  //           error: "",
  //           cart_items: [...newCartItems], // Set the new cart items
  //           totalValue: response.data.total, // Set the total value
  //         }));
  //       }
  //       toggleState("isCartLoading", false);
  //     }
  //   } catch {
  //     toggleState("isCartLoading", false);
  //     console.error("Unable to get cart items");
  //   }
  // };

  // const handleRemoveFromCart = async (item_id: string) => {
  //   try {
  //     if (isAuthenticated) {
  //       const response = await RemoveFromCart(item_id, getToken);
  //       if (response.error === null) {
  //         handleDeletionInCart(item_id);
  //         await handleGetCartItems();
  //         handleMessage("Item removed from cart successfully!");
  //       }
  //     }
  //   } catch {
  //     console.error("Unable to remove item from cart.");
  //   }
  // };

  const handleSearchChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const value = e.target.value;
      if (value) {
        const results = await Search(value);
        if (
          results.data !== null &&
          results.error === null
          // results.data.count !== 0
        ) {
          setState((prev) => ({
            ...prev,
            searchResults: results.data,
          }));
        } else {
          setState((prev) => ({ ...prev, searchResults: [] }));
        }
      } else {
        setState((prev) => ({ ...prev, searchResults: [] }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const toggleState = (key: keyof typeof state, value?: boolean) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value
        ? value
        : typeof prevState[key] === "boolean"
        ? !prevState[key]
        : prevState[key],
    }));
  };

  const closeDropdowns = () => {
    setState((prev) => ({
      ...prev,
      isUserDropdownOpen: false,
      isMessageDropdownOpen: false,
      isCartDropdownOpen: false,
    }));
  };

  // const handleModalClose = () => {
  //   if (state.cart_items.length > 0) {
  //     toggleState("isCheckoutOpen");
  //     toggleState("isCartDropdownOpen");
  //   } else {
  //     setState((prev) => ({ ...prev, error: "Please add items to cart" }));
  //   }
  // };

  const toggleSidebar = (options: any) => {
    setState((prev) => ({
      ...prev,
      isLeftSidebarOpen: options.isLeftSidebarOpen ?? prev.isLeftSidebarOpen,
      isRightSidebarOpen: options.isRightSidebarOpen ?? prev.isRightSidebarOpen,
    }));
  };

  return (
    <>
      <header>
        <div
          className={`container py-2 mb-4 ${
            state.isLeftSidebarOpen || state.isRightSidebarOpen
              ? "sidebar-header"
              : ""
          }`}
        >
          <nav className="navbar navbar-expand-lg">
            <div className="container">
              <Link className="navbar-brand z-1" to="/">
                <img src={logo} alt="logo" className="logo-width" />
              </Link>
              <div className="header-search">
                <div className="d-flex align-items-center">
                  <div className="custom-icons">
                    <span
                      className={`magic-icon-search ${
                        state.isLeftSidebarOpen ? "close" : ""
                      }`}
                      onClick={() =>
                        toggleSidebar({
                          isLeftSidebarOpen: !state.isLeftSidebarOpen,
                          isRightSidebarOpen: false,
                        })
                      }
                    ></span>
                  </div>

                  <div
                    className={`left-sidebar ${
                      state.isLeftSidebarOpen ? "active" : ""
                    }`}
                  >
                    <SearchSideBar
                      isOpen={state.isLeftSidebarOpen}
                      searchResults={state.searchResults}
                      handleSearchChange={handleSearchChange}
                      onResultClick={() =>
                        toggleSidebar({
                          isLeftSidebarOpen: false,
                          isRightSidebarOpen: state.isRightSidebarOpen,
                        })
                      }
                    />
                  </div>
                  <div
                    className={`right-sidebar ${
                      state.isRightSidebarOpen ? "active" : ""
                    }`}
                  >
                    <HamburgerSidebar
                      handleLogout={() => {
                        logout();
                        closeDropdowns();
                      }}
                      isOpen={state.isRightSidebarOpen}
                      handleClick={() =>
                        toggleSidebar({
                          isRightSidebarOpen: false,
                          isLeftSidebarOpen: state.isLeftSidebarOpen,
                        })
                      }
                      isAuthenticated={isAuthenticated}
                      is_fan1_verified={state.role === "moderator"}
                      isNewNotification={isNewNotification}
                    />
                  </div>

                  <div className="custom-icons">
                    <input
                      type="checkbox"
                      id="hamburger-check"
                      className="bar-checkbox height-width-0"
                      checked={state.isRightSidebarOpen}
                      onChange={() =>
                        toggleSidebar({
                          isRightSidebarOpen: !state.isRightSidebarOpen,
                          isLeftSidebarOpen: false,
                        })
                      }
                    />
                    <label htmlFor="hamburger-check">
                      <div className="hamburger">
                        <span className="bar bar1 top-0"></span>
                        <span className="bar bar2"></span>
                        <span className="bar bar3 "></span>
                        <span className="bar bar4 bottom-0"></span>
                      </div>
                    </label>
                  </div>
                </div>
              </div>

              <div
                className="collapse navbar-collapse justify-content-end"
                id="navbarSupportedContent"
              >
                <ul
                  className="navbar-nav mb-2 mb-lg-0 align-items-center"
                  style={{ gap: "30px" }}
                >
                  <li className="d-block">
                    <div className="collapsible-search">
                      <SearchComponent
                        className={"CollapsibleSearch my-auto mt-1"}
                        searchResults={state.searchResults}
                        handleSearchChange={handleSearchChange}
                        isFocusSearch={isFocusSearch}
                      />
                    </div>
                  </li>
                  {!isAuthenticated ? (
                    <>
                      <li className="nav-item">
                        <Link className="nav-link" to="/fans">
                          Fans
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link" to="/famous">
                          Famous?
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link" to="/learn">
                          Learn
                        </Link>
                      </li>
                    </>
                  ) : (
                    <>
                      <li className="nav-item">
                        <Link
                          to={{
                            pathname: `${
                              isNewNotification ? "/alerts" : "/message"
                            }`,
                          }}
                          className="icon-box alert-message"
                          onClick={() => {
                            toggleState("isMessageDropdownOpen");
                          }}
                        >
                          <svg
                            width="19"
                            height="18"
                            viewBox="0 0 19 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onMouseOver={() => {
                              setState((prev) => ({
                                ...prev,
                                isMessageHover: true,
                              }));
                            }}
                            onMouseLeave={() => {
                              setState((prev) => ({
                                ...prev,
                                isMessageHover: false,
                              }));
                            }}
                          >
                            <g clipPath="url(#clip0_5504_32002)">
                              <path
                                d="M15.8583 0H2.26449C1.01629 0 0 1.01629 0 2.2338V12.3967C0 13.6449 1.01629 14.6305 2.26449 14.6305H5.66465V17.5737C5.66465 17.9216 6.05684 18.1228 6.3399 17.9182L10.7632 14.5998H15.8617C17.1099 14.5998 18.1262 13.5836 18.1262 12.366V2.2338C18.1262 1.01629 17.1372 0 15.8583 0ZM17.0246 12.4615C17.0246 13.0856 16.5165 13.5938 15.8924 13.5938H10.7905C10.5449 13.5938 10.3062 13.6722 10.1118 13.8223L6.831 16.2846V14.1599C6.831 13.8462 6.57863 13.5938 6.26487 13.5938H2.2986C1.6745 13.5938 1.16635 13.0856 1.16635 12.4615V2.26449C1.16635 1.64039 1.6745 1.13225 2.2986 1.13225H15.8924C16.5165 1.13225 17.0246 1.64039 17.0246 2.26449V12.4615Z"
                                fill={
                                  state.isMessageHover ? "#8671FC" : "white"
                                }
                              />
                              <path
                                d="M14.477 5.12585H3.68656C3.33188 5.12585 3.04541 5.41233 3.04541 5.76701C3.04541 6.12169 3.33188 6.40816 3.68656 6.40816H14.477C14.8317 6.40816 15.1182 6.12169 15.1182 5.76701C15.1182 5.41233 14.8317 5.12585 14.477 5.12585Z"
                                fill={
                                  state.isMessageHover ? "#8671FC" : "white"
                                }
                              />
                              <path
                                d="M13.3516 8.09619H3.68656C3.33188 8.09619 3.04541 8.38266 3.04541 8.73734C3.04541 9.09202 3.33188 9.3785 3.68656 9.3785H13.3516C13.7063 9.3785 13.9927 9.09202 13.9927 8.73734C13.9927 8.38266 13.7063 8.09619 13.3516 8.09619Z"
                                fill={
                                  state.isMessageHover ? "#8671FC" : "white"
                                }
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_5504_32002">
                                <rect
                                  width="18.1262"
                                  height="18"
                                  fill="white"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                          {isNewNotification && (
                            <div className="alert-badge"></div>
                          )}
                        </Link>
                      </li>
                    </>
                  )}
                  <li className="nav-item">
                    <NavbarDropdown
                      className={"dropdown-secondary"}
                      icon={
                        state.isUserDropdownOpen ? (
                          <div className="hamburger-cross">
                            <i className="fa-solid fa-xmark font-26"></i>
                          </div>
                        ) : (
                          <label htmlFor="hamburger-check">
                            <div className="hamburger">
                              <span className="bar bar1 top-0"></span>
                              <span className="bar bar2"></span>
                              <span className="bar bar3 "></span>
                              <span className="bar bar4 bottom-0"></span>
                            </div>
                          </label>
                        )
                      }
                      isOpen={state.isUserDropdownOpen}
                      onToggle={() => toggleState("isUserDropdownOpen")}
                    >
                      {isAuthenticated ? (
                        <>
                          {state.role === "moderator" && (
                            <Link
                              className="text-decoration-none"
                              to="/settings/listing"
                              onClick={closeDropdowns}
                            >
                              <p>My Listing</p>
                            </Link>
                          )}
                          <Link
                            className="text-decoration-none"
                            to="/memberships"
                            onClick={closeDropdowns}
                          >
                            <p>My Memberships</p>
                          </Link>
                          <Link
                            className="text-decoration-none"
                            to="/following"
                            onClick={closeDropdowns}
                          >
                            <p>Following</p>
                          </Link>
                          <div className="bottom-border-solid my-1" />
                          <Link
                            className="text-decoration-none"
                            to="/rankings"
                            onClick={closeDropdowns}
                          >
                            <p>Rankings</p>
                          </Link>
                          <Link
                            className="text-decoration-none"
                            to="/available"
                            onClick={closeDropdowns}
                          >
                            <p>Available Now</p>
                          </Link>
                          {state.role !== "moderator" && (
                            <Link
                              className="text-decoration-none"
                              to="/famous"
                              onClick={closeDropdowns}
                            >
                              <p>Famous?</p>
                            </Link>
                          )}
                          <div className="bottom-border-solid my-1" />
                          <Link
                            className="text-decoration-none"
                            to="/learn"
                            onClick={closeDropdowns}
                          >
                            <p>Learn</p>
                          </Link>
                          <Link
                            className="text-decoration-none"
                            to="/settings/profile"
                            onClick={closeDropdowns}
                          >
                            <p>Settings</p>
                          </Link>
                          <Button
                            label="Sign Out"
                            onClick={() => {
                              logout();
                              closeDropdowns();
                            }}
                            className="logout-btn dropdown-btn mt-2 py-1"
                          />
                        </>
                      ) : (
                        <>
                          <Link
                            className="text-decoration-none"
                            to="/rankings"
                            onClick={closeDropdowns}
                          >
                            <p>Rankings</p>
                          </Link>
                          <Link
                            className="text-decoration-none"
                            to="/available"
                            onClick={closeDropdowns}
                          >
                            <p>Available Now</p>
                          </Link>
                          <div
                            className="icon w-100"
                            onClick={() => {
                              closeDropdowns();
                              login();
                            }}
                          >
                            <p>Settings</p>
                          </div>
                          <div className="d-flex gap-2 mt-2">
                            <Button
                              label="Sign Up"
                              onClick={() => {
                                signup();
                              }}
                              className="logout-btn signin-btn dropdown-btn mt-2 py-1"
                            />
                            <Button
                              label="Sign In"
                              onClick={() => {
                                login();
                              }}
                              className="logout-btn dropdown-btn mt-2 py-1"
                            />
                          </div>
                        </>
                      )}
                    </NavbarDropdown>
                  </li>
                  {/* {isAuthenticated ? (
                    <NavbarDropdown
                      className={"end-0"}
                      icon={
                        <svg
                          width="21"
                          height="18"
                          viewBox="0 0 21 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onMouseOver={()=>{setState((prev)=>({...prev, isIconHover:true}))}}
                          onMouseLeave={()=>{setState((prev)=>({...prev, isIconHover:false}))}}
                        >
                          <path
                            d="M6.468 14.064C5.382 14.064 4.5 14.946 4.5 16.032C4.5 17.118 5.382 18 6.468 18C7.554 18 8.436 17.118 8.436 16.032C8.436 14.946 7.554 14.064 6.468 14.064ZM6.468 16.875C6 16.875 5.625 16.5 5.625 16.032C5.625 15.564 6 15.189 6.468 15.189C6.936 15.189 7.311 15.564 7.311 16.032C7.311 16.5 6.936 16.875 6.468 16.875Z"
                            fill={state.isIconHover || state.isCartDropdownOpen? "#8671FC" : "white"}
                          />
                          <path
                            d="M16.0322 14.064C14.9462 14.064 14.0642 14.946 14.0642 16.032C14.0642 17.118 14.9462 18 16.0322 18C17.1182 18 18.0002 17.118 18.0002 16.032C18.0002 14.946 17.1182 14.064 16.0322 14.064ZM16.0322 16.875C15.5642 16.875 15.1892 16.5 15.1892 16.032C15.1892 15.564 15.5642 15.189 16.0322 15.189C16.5002 15.189 16.8752 15.564 16.8752 16.032C16.8752 16.5 16.5002 16.875 16.0322 16.875Z"
                            fill={state.isIconHover || state.isCartDropdownOpen? "#8671FC" : "white"}
                          />
                          <path
                            d="M19.0471 1.125H3.51609L3.36009 0.438C3.30309 0.183 3.07509 0 2.81409 0H0.591095C0.312095 0 0.0510947 0.192 0.00909474 0.468C-0.0479053 0.822 0.222095 1.125 0.564095 1.125H2.36409L2.49909 1.713C2.50509 1.746 2.51709 1.776 2.52909 1.806L5.0641 13.044C5.07309 13.08 5.0911 13.11 5.1031 13.14C5.1061 13.149 5.1091 13.155 5.1121 13.164C5.1241 13.191 5.1361 13.218 5.1511 13.239C5.2531 13.398 5.4271 13.5 5.6251 13.5H17.4031C17.6821 13.5 17.9461 13.311 17.9911 13.035C18.0511 12.684 17.7781 12.375 17.4361 12.375H6.0751L5.5621 10.125H17.1481C17.6521 10.125 18.0931 9.792 18.2311 9.306L20.1301 2.556C20.3311 1.839 19.7611 1.128 19.0471 1.128V1.125ZM17.1481 9H5.3041L3.78009 2.25H19.0471L17.1481 9Z"
                            fill={state.isIconHover || state.isCartDropdownOpen? "#8671FC" : "white"}
                          />
                          <path
                            d="M6.66019 4.85102H16.1522C16.4642 4.85102 16.7162 4.59902 16.7162 4.28702C16.7162 3.97502 16.4642 3.72302 16.1522 3.72302H6.66019C6.34819 3.72302 6.09619 3.97502 6.09619 4.28702C6.09619 4.59902 6.34819 4.85102 6.66019 4.85102Z"
                            fill={state.isIconHover || state.isCartDropdownOpen? "#8671FC" : "white"}
                          />
                          <path
                            d="M15.6571 6.33899H7.15506C6.84306 6.33899 6.59106 6.59099 6.59106 6.90299C6.59106 7.21499 6.84306 7.46699 7.15506 7.46699H15.6571C15.9691 7.46699 16.2211 7.21499 16.2211 6.90299C16.2211 6.59099 15.9691 6.33899 15.6571 6.33899Z"
                            fill={state.isIconHover || state.isCartDropdownOpen? "#8671FC" : "white"}
                          />
                        </svg>
                      }
                      isOpen={state.isCartDropdownOpen}
                      onToggle={() => toggleState("isCartDropdownOpen")}
                    >
                      <div className="row my-3 mx-1">
                        <Button
                          className="col-1 p-1 close-btn"
                          variant="dark"
                          label={<i className="fa-solid fa-close"></i>}
                          onClick={closeDropdowns}
                        />
                        <h3 className="col-12 d-flex justify-content-center mb-3">
                          Your Cart
                        </h3>
                        <div className="cart-height">
                          {state.isCartDropdownOpen && state.isCartLoading ? (
                            <div className="cart-loader">
                              <div className="spinner"></div>
                            </div>
                          ) : (
                            <>
                              {state.cart_items.map((cart_item, index) => (
                                <Slab
                                  key={cart_item.item_id}
                                  className={
                                    index === state.cart_items.length - 1
                                      ? ""
                                      : "pb-3"
                                  }
                                  content={
                                    <>
                                      <img
                                        src={cart_item.item_image_url}
                                        alt={cart_item.item_name}
                                        style={{
                                          width: "70px",
                                          height: "70px",
                                        }}
                                        className="image col-1 p-0"
                                      />
                                      <div
                                        className="col d-flex align-items-center justify-content-between"
                                        style={{ width: "370px" }}
                                      >
                                        <div
                                          className="py-3 text-start content-link"
                                          onClick={() =>
                                            toggleState("isCartDropdownOpen")
                                          }
                                        >
                                          <Link
                                            to={{
                                              pathname: `/my-listing/${cart_item.item_id}`,
                                            }}
                                            className="ms-2 text-decoration-none purple-color font-18"
                                          >
                                            {cart_item.item_name}
                                          </Link>
                                        </div>
                                        <div className="d-flex align-items-center">
                                          <div className="p-0 font-inter-400-14">
                                            ${cart_item.item_price}
                                          </div>
                                          <i
                                            className="fa-regular fa-trash-can ms-3 cart-trash-icons"
                                            onClick={() => {
                                              handleRemoveFromCart(
                                                cart_item.item_id
                                              );
                                            }}
                                          ></i>
                                        </div>
                                      </div>
                                    </>
                                  }
                                />
                              ))}
                            </>
                          )}
                        </div>
                        <Slab
                          content={
                            <>
                              <div
                                className="py-3 mt-3 col d-flex justify-content-between border-top font-18 font-500"
                                style={{ width: "370px" }}
                              >
                                <div className="text-start">Total</div>
                                <div className="p-0">${state.totalValue}</div>
                              </div>
                            </>
                          }
                        />
                        {state.error && (
                          <div className="text-danger text-center">
                            {state.error}
                          </div>
                        )}
                        <Button
                          type="button"
                          className="col-12 py-2 btn-primary font-22 mt-2"
                          onClick={handleModalClose}
                          label={"Checkout"}
                        />
                      </div>
                    </NavbarDropdown>
                  ) : (
                    <div className="header-icons icon-box"> 
                      <svg
                        width="21"
                        height="18"
                        viewBox="0 0 21 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onMouseOver={()=>{setState((prev)=>({...prev, isIconHover:true}))}}
                        onMouseLeave={()=>{setState((prev)=>({...prev, isIconHover:false}))}}
                        >
                        <g clipPath="url(#clip0_5504_32013)" >
                          <path
                            d="M6.468 14.064C5.382 14.064 4.5 14.946 4.5 16.032C4.5 17.118 5.382 18 6.468 18C7.554 18 8.436 17.118 8.436 16.032C8.436 14.946 7.554 14.064 6.468 14.064ZM6.468 16.875C6 16.875 5.625 16.5 5.625 16.032C5.625 15.564 6 15.189 6.468 15.189C6.936 15.189 7.311 15.564 7.311 16.032C7.311 16.5 6.936 16.875 6.468 16.875Z"
                            fill={state.isIconHover? "#8671FC" : "white"}
                          />
                          <path
                            d="M16.0322 14.064C14.9462 14.064 14.0642 14.946 14.0642 16.032C14.0642 17.118 14.9462 18 16.0322 18C17.1182 18 18.0002 17.118 18.0002 16.032C18.0002 14.946 17.1182 14.064 16.0322 14.064ZM16.0322 16.875C15.5642 16.875 15.1892 16.5 15.1892 16.032C15.1892 15.564 15.5642 15.189 16.0322 15.189C16.5002 15.189 16.8752 15.564 16.8752 16.032C16.8752 16.5 16.5002 16.875 16.0322 16.875Z"
                            fill={state.isIconHover? "#8671FC" : "white"}
                            />
                          <path
                            d="M19.0471 1.125H3.51609L3.36009 0.438C3.30309 0.183 3.07509 0 2.81409 0H0.591095C0.312095 0 0.0510947 0.192 0.00909474 0.468C-0.0479053 0.822 0.222095 1.125 0.564095 1.125H2.36409L2.49909 1.713C2.50509 1.746 2.51709 1.776 2.52909 1.806L5.0641 13.044C5.07309 13.08 5.0911 13.11 5.1031 13.14C5.1061 13.149 5.1091 13.155 5.1121 13.164C5.1241 13.191 5.1361 13.218 5.1511 13.239C5.2531 13.398 5.4271 13.5 5.6251 13.5H17.4031C17.6821 13.5 17.9461 13.311 17.9911 13.035C18.0511 12.684 17.7781 12.375 17.4361 12.375H6.0751L5.5621 10.125H17.1481C17.6521 10.125 18.0931 9.792 18.2311 9.306L20.1301 2.556C20.3311 1.839 19.7611 1.128 19.0471 1.128V1.125ZM17.1481 9H5.3041L3.78009 2.25H19.0471L17.1481 9Z"
                            fill={state.isIconHover? "#8671FC" : "white"}
                            />
                          <path 
                            d="M6.66019 4.85102H16.1522C16.4642 4.85102 16.7162 4.59902 16.7162 4.28702C16.7162 3.97502 16.4642 3.72302 16.1522 3.72302H6.66019C6.34819 3.72302 6.09619 3.97502 6.09619 4.28702C6.09619 4.59902 6.34819 4.85102 6.66019 4.85102Z"
                            fill={state.isIconHover? "#8671FC" : "white"}
                          />
                          <path
                            d="M15.6571 6.33899H7.15506C6.84306 6.33899 6.59106 6.59099 6.59106 6.90299C6.59106 7.21499 6.84306 7.46699 7.15506 7.46699H15.6571C15.9691 7.46699 16.2211 7.21499 16.2211 6.90299C16.2211 6.59099 15.9691 6.33899 15.6571 6.33899Z"
                            fill={state.isIconHover? "#8671FC" : "white"}
                            />
                        </g>
                        <defs>
                          <clipPath id="clip0_5504_32013">
                            <rect width="20.172" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  )} */}
                </ul>
              </div>
            </div>
          </nav>
        </div>
        <div
          className={
            state.isLeftSidebarOpen || state.isRightSidebarOpen
              ? "sidebar-header-space"
              : ""
          }
        ></div>
      </header>

      <StripeCheckoutForm
        isVisible={state.isCheckoutOpen}
        itemIds={state.cart_items.map((item) => item.item_id)}
        onClose={() => {
          toggleState("isCheckoutOpen");
        }}
      />
    </>
  );
};

export default Header;
